<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">{{ cardTitle }}</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />

    <form @submit.prevent="subimtData()">
      <!--begin::Body-->
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">مقدم الطلب:</label>
            <div>{{ (dataRow.User)? dataRow.User.name : 'غير معروف' }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">رقم الجوال:</label>
            <div>{{ (dataRow.User)? dataRow.User.mobile : 'غير معروف' }}</div>
          </div>
        </div>
        
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">يطلب تغيير الحساب إلى:</label>
            <div>{{ accountTypes[dataRow.accountTypeRequested] }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">مصدر الطلب:</label>
              <div>
                <span v-if="dataRow.requestSource === 'admin'" class="badge bg-secondary">Admin</span>
                <span v-else-if="dataRow.requestSource === 'ios'" class="badge bg-primary">IOS</span>
                <span v-else-if="dataRow.requestSource === 'android'" class="badge bg-primary">Android</span>
                <span v-else-if="dataRow.requestSource === 'website'" class="badge bg-info">Website</span>
                <span v-else-if="dataRow.requestSource" class="badge bg-light text-dark">{{ dataRow.requestSource }}</span>
                <span v-else class="text-muted">غير محدد</span>
              </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">رقم رخصة فال:</label>
            <div>{{ dataRow.falLicense }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">تاريخ إنتهاء رخصة فال:</label>
            <div>{{ dataRow.falExpireDate }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">صورة رخصة فال:</label>
            <div>
              <a v-if="dataRow.falFile" :href="MEDIA_URL+dataRow.falFile">صورة الرخصة</a>
              <span v-else>لا يوجد</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">رقم السجل التجاري:</label>
            <div>{{ dataRow.commercialRegister }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">صورة السجل التجاري:</label>
            <div>
              <a v-if="dataRow.commercialRegisterFile" :href="MEDIA_URL+dataRow.commercialRegisterFile">صورة السجل</a>
              <span v-else>لا يوجد</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">اسم الشركة:</label>
            <div>{{ dataRow.companyName }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">عن الشركة:</label>
            <div>{{ dataRow.bio }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">رقم جوال الشركة:</label>
            <div>{{ dataRow.companyNumber }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">شعار الشركة:</label>
            <div>
              <a v-if="dataRow.logo" :href="MEDIA_URL+dataRow.logo">صورة الشعار</a>
              <span v-else>لا يوجد</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">حالة الطلب:</label>
            <select v-model="status" class="form-control">
              <option v-for="(val, key) in statusChoices" :value="key" :key="key">{{ val }}</option>
            </select>
          </div>
        </div>
      </div>
      <!--end::Body-->
      <!--begin::Footer-->
      <div class="card-footer">
        <div class="row">
          <div class="col text-end">
            <button v-if="!formLoader" type="submit" class="btn btn-success">ارسل</button>
            <loader v-if="formLoader" />
          </div>
        </div>
      </div>
      <!--end::Footer-->
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import { toast, formatDate } from '@/helpers/tools';
import { mapGetters } from 'vuex';

export default {
  name: 'AccountDetailsForm',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
    statusObject: {
      type: Object,
      default: null,
    },
    accountTypes: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      statusChoices: {},
      status: 'pending',
    }
  },
  computed:{...mapGetters(['MEDIA_URL'])},
  methods: {
    formatDate,
    subimtData(){
      this.formLoader = true;
      this.hasError = false;
      this.hasSucess = false;
      if((!this.note || this.note.trim() == '') && this.status == 'rejected'){
        this.message = 'يجب كتابة سبب الرفض';
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
        return false;
      }
      
      let api = null;
      if(this.dataRow)
        api = this.$http.put(`/api/admin/accountDetails/update/${this.dataRow.id}`, {
          status: this.status,
        });
      else
        return false;
        // api = this.$http.post('/api/admin/properties/create', formData);
      api.then(({data}) => {
        if(false){
          toast('تم إضافة الإعلان بنجاح', 'success');
          this.$router.replace('/propertyDoc').catch(() => {});
        }else{
          this.message = 'تم التعديل بنجاح';
          this.hasSucess = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
  },
  created(){
    if(this.dataRow){
      this.status = this.dataRow.status;
    }
    this.statusChoices = this.statusObject;
  }
}
</script>
